import { Component } from 'react';
import { hasLoginCookie } from '../../helpers/cookies';
import { Utils } from 'autenti-components';
class CheckIfLogged extends Component {
    componentDidMount() {
        const { redirectUrl } = this.props;
        if (!hasLoginCookie()) {
            const redirect = new URL(redirectUrl ? redirectUrl : `${Utils.getUrlTo('accounts')}/login`);
            let redirectString = redirect.toString();
            const returnString = redirect.searchParams.get('return') || '';
            if (returnString) {
                const returnUrl = new URL(returnString);
                if (returnUrl.searchParams.has('autoLogout')) {
                    returnUrl.searchParams.delete('autoLogout');
                    redirect.searchParams.set('return', returnUrl.toString());
                    redirectString = redirect.toString();
                    redirectString += '&autoLogout';
                }
            }
            else if (redirectUrl || window.location.href) {
                const loginUrl = new URL(`${Utils.getUrlTo('accounts')}/login`);
                const redirectUrlObj = new URL(redirectUrl ? redirectUrl : window.location.href);
                let addAutoLogout = false;
                if (redirectUrlObj.searchParams.has('autoLogout')) {
                    redirectUrlObj.searchParams.delete('autoLogout');
                    addAutoLogout = true;
                }
                loginUrl.searchParams.set('return', redirectUrlObj.toString());
                redirectString = loginUrl.toString();
                if (addAutoLogout) {
                    redirectString += '&autoLogout';
                }
            }
            window.location.href = redirectString;
        }
    }
    render() {
        return null;
    }
}
export default CheckIfLogged;
